import { useState } from 'react';
import { Box, Button, TextField } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import Modal from '../Modal';
import { submitUtr } from '../../../store/actions/authActionCreator';
import { showMessage } from '../../../utils/helper';

function SubmitUtrModal({ open, onClose, remittanceId, onSuccess }) {
    const [utr, setUtr] = useState('');
    const [transactionDate, setTransactionDate] = useState('');
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const handleClose = () => {
        setUtr('');
        setTransactionDate('');
        setLoading(false);
        onClose?.();
    };

    const handleSubmit = () => {
        if (!utr || !transactionDate) {
            showMessage('Please fill all required fields', 'error');
            return;
        }
        setLoading(true);
        dispatch(
            submitUtr(
                { remittanceId, utr, transactionDate },
                () => {
                    setLoading(false);
                    showMessage('UTR submitted successfully!', 'success');
                    onSuccess?.();
                    handleClose();
                },
                () => {
                    setLoading(false);
                    showMessage('Failed to submit UTR', 'error');
                    handleClose();
                }
            )
        );
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            title="Submit UTR"
            maxWidth="sm"
        >
            <Box style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '8px 0' }}>
                <TextField
                    label="UTR Number"
                    variant="outlined"
                    fullWidth
                    required
                    value={utr}
                    onChange={(e) => setUtr(e.target.value)}
                />
                <TextField
                    label="Transaction Date"
                    type="date"
                    variant="outlined"
                    fullWidth
                    required
                    InputLabelProps={{ shrink: true }}
                    value={transactionDate}
                    onChange={(e) => setTransactionDate(e.target.value)}
                />
                <Box style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '8px' }}>
                    <Button variant="outlined" onClick={handleClose} disabled={loading}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? 'Submitting...' : 'Submit UTR'}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}

export default SubmitUtrModal;
